module.exports = __webpack_public_path__ + "static/img/product2.0248660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yellow/product2.png
// module id = 4eY4
// module chunks = 0